import { render, staticRenderFns } from "./HeaderV2.ts.vue?vue&type=template&id=5137e70b"
import script from "./HeaderV2.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderV2.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderV2.ts.vue?vue&type=style&index=0&id=5137e70b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports